import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { CardModel } from '../finance.model';

@Component({
  selector: 'finance-card-dialog',
  standalone: false,
  template: `
    <form #form="ngForm" (ngSubmit)="save()">
      <h2 mat-dialog-title>{{ card.id ? 'Modify' : 'Create' }} Card</h2>
      <mat-dialog-content>
        <mat-form-field>
          <mat-label>Name</mat-label>
          <input matInput [(ngModel)]="card.name" name="name" placeholder="Nubank, XP Visa..." required>
        </mat-form-field>
        <mat-divider></mat-divider>
        <mat-form-field>
          <mat-label>Closing day</mat-label>
          <input matInput type="number" min="1" max="31" [(ngModel)]="card.closingDay" name="closingDay">
        </mat-form-field>
        &nbsp;&nbsp;
        <mat-form-field>
          <mat-label>Due day</mat-label>
          <input matInput type="number" min="1" max="31" [(ngModel)]="card.dueDay" name="dueDay">
        </mat-form-field>
        <section>
          <mat-checkbox [(ngModel)]="card.active" name="active">Active</mat-checkbox>
        </section>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button type="submit" [disabled]="form.invalid">Save</button>
        <button mat-raised-button type="button" mat-dialog-close>Cancel</button>
      </mat-dialog-actions>
    </form>
  `
})
export class CardDialogComponent {
  card: CardModel;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: Partial<CardModel>,
    private dialogRef: MatDialogRef<CardDialogComponent>
  ) {
    this.card = { id: '', name: '', closingDay: null, dueDay: null, active: true, ...data };
  }

  save(): void {
    this.dialogRef.close({ ...this.card, name: this.card.name.trim() });
  }
}
